<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
      <h4> افزودن عضو جدید</h4>
      <feather-icon icon="XIcon" @click.stop="$router.go(-1)" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="perfectScrollbarSettings" :key="$vs.rtl">

      <vs-tabs v-model="tab">
        <vs-tab label="انتخاب دانش آموز">
          <div class="p-6" style="min-height: 30vh">
            <label>انتخاب دانش آموز</label>
            <v-select placeholder="انتخاب دانش آموز" v-model="selectedUser" :options="users" dir="rtl"/>
            <br>
            <vs-button v-show="user.userId" class="my-3" @click="mapIsVisible=true">تغییر آدرس پیشفرض</vs-button>
            <div v-if="mapIsVisible && user.userId">
              <vs-textarea label="آدرس" v-model="user.homeLocationText"></vs-textarea>

              <select-location :default.sync="this.user.homeLocationLatLong"
                               :edit-lock="false" @change="locationChanged"></select-location>
            </div>
          </div>
        </vs-tab>
        <vs-tab @click="selectedUser=null" label="انتخاب گروه">
          <div class="p-6" style="min-height: 30vh">
            <label>انتخاب گروه</label>
            <v-select class="mt-2" placeholder="انتخاب گروه" v-model="selectedCohort" :options="cohorts" dir="rtl"/>
            <vs-checkbox class="mt-3" v-model="onlyLockedUser">فقط دانش آموزان تایید شده</vs-checkbox>
          </div>
        </vs-tab>

      </vs-tabs>

    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button :disabled="!user.userId && !selectedCohort" @click="addTaskMember" class="mr-6">افزودن</vs-button>
      <vs-button type="border" color="danger" @click="$router.go(-1)">انصراف</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import vSelect from 'vue-select'
  import SelectLocation from "../../../components/map/SelectLocation";

  export default {
    name: 'TaskAddMember',
    components: {
      SelectLocation,
      'v-select': vSelect,
      VuePerfectScrollbar,
    },
    mounted() {
      if (!this.cohorts.length)
        this.$store.dispatch('fetchCohorts')
      this.$store.dispatch('fetchStudents')
      window.addEventListener("popstate", e => this.closeSidebar());
    },
    data() {
      return {
        tab: 0,
        mapIsVisible: false,
        user: {
          homeLocationLatLong: '',
          homeLocationText: '',
          taskId: '',
          userId: ''
        },
        perfectScrollbarSettings: {
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
        selectedUser: null,
        selectedCohort: null,
        onlyLockedUser: false
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
          }
        }
      },
      users() {
        return this.$store.state.students
          .filter(i => {
            return !this.taskMemberIds.includes(i.id);
          })
          .map(i => {
            return {
              value: i.id,
              label: i.firstName + ' ' + i.lastName,
              LatLng: {
                latitude: i.homeLocationLatLong.latitude,
                longitude: i.homeLocationLatLong.longitude,
              },
              address: i.homeLocationText
            }
          })
      },
      taskMemberIds() {
        return this.$store.state.task.members.map(i => i.id)
      },
      cohorts() {
        return this.$store.state.cohorts.map(i => {
          return {
            'label': i.name,
            'value': i.id,
          }
        });
      }
    },
    methods: {
      locationChanged(val) {
        this.user.homeLocationLatLong = val
      },
      addTaskMember() {
        if (this.selectedCohort) {
          const taskId = Number(this.$store.state.task.id)
          const oldTaskMemberIds = this.$store.state.task.members.map(i => i.id)
          const payload = this.$store.state.students
            .filter(i => !oldTaskMemberIds.includes(i.id))
            .filter(i => i.groups.map(x => x.id).includes(this.selectedCohort.value))
            .filter(i => this.onlyLockedUser ? i.locked : true)
            .map(i => {
              return {
                taskId: taskId,
                userId: i.id,
                homeLocationLatLong: i.homeLocationLatLong,
                homeLocationText: i.homeLocationText,
              }
            })
          if (payload.length) {
            this.$store.dispatch('addTaskMembers', payload).then(() => {
              this.selectedCohort = null
              this.isSidebarActiveLocal = false
            })
          } else {
            alert('همه اعضای این گروه قبلا اضافه شده اند')
            this.selectedCohort = null
          }
        } else {
          if (!this.user.homeLocationLatLong.latitude || !this.user.userId) {
            alert('اطلاعات دانش آموز را تکمیل کنید')
            return
          }
          this.user.taskId = Number(this.$store.state.task.id)
          this.$store.dispatch('addTaskMember', this.user).then(() => {
            this.user = {
              homeLocationLatLong: '',
              homeLocationText: '',
              taskId: '',
              userId: ''
            }
            this.selectedUser = null
            this.isSidebarActiveLocal = false
          })
        }

      },
      closeSidebar() {
        this.isSidebarActiveLocal = false
      }
    },
    watch: {
      selectedUser(item) {
        this.mapIsVisible = false;
        if (item) {
          this.user.homeLocationLatLong = item.LatLng
          this.user.homeLocationText = item.address
          this.user.userId = item.value
        } else {
          this.user.userId = null
        }
      },
      isSidebarActiveLocal(val) {
        if (val)
          window.history.pushState(null, null, '#modal');
      },
      tab(val) {
        this.selectedUser = null
        this.selectedCohort = null
      }
    },
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      }
    },
  }
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 500px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .vs-tabs--content {
    position: relative;
    width: 100%;
    display: block;
    padding: 10px;
    min-height: 700px;
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  }
</style>
